// source: pbtypes/gen/skills/ui_input_axis.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.UiInputAxis', null, global);
goog.exportSymbol('proto.skills.UiInputAxis.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.UiInputAxis = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.UiInputAxis, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.UiInputAxis.displayName = 'proto.skills.UiInputAxis';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.UiInputAxis.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.UiInputAxis.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.UiInputAxis} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiInputAxis.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.UiInputAxis}
 */
proto.skills.UiInputAxis.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.UiInputAxis;
  return proto.skills.UiInputAxis.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.UiInputAxis} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.UiInputAxis}
 */
proto.skills.UiInputAxis.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.UiInputAxis.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.UiInputAxis.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.UiInputAxis} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiInputAxis.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.skills.UiInputAxis.Enum = {
  UP: 0,
  RIGHT: 1,
  FORWARD: 2,
  YAW: 3,
  PITCH: 4,
  YAW_BUTTONS: 32,
  STRAFE_BUTTONS: 33,
  AZIMUTH_BUTTONS: 34,
  HEIGHT_SLIDER: 11,
  RANGE_SLIDER: 12,
  HEIGHT_BUTTONS: 35,
  RANGE_BUTTONS: 36,
  STEERING_STICK_X: 37,
  STEERING_STICK_Y: 38,
  STRAFING_STICK_X: 39,
  STRAFING_STICK_Y: 40,
  LEFT_TRIGGER: 5,
  RIGHT_TRIGGER: 6,
  LEFT_STICK_X: 7,
  LEFT_STICK_Y: 8,
  RIGHT_STICK_X: 9,
  RIGHT_STICK_Y: 10,
  START_BUTTON: 13,
  STOP_BUTTON: 14,
  PLUS_BUTTON: 15,
  MINUS_BUTTON: 16,
  A_BUTTON: 17,
  B_BUTTON: 18,
  C_BUTTON: 19,
  X_BUTTON: 24,
  Y_BUTTON: 25,
  Z_BUTTON: 26,
  HOME_BUTTON: 27,
  MENU_BUTTON: 28,
  MAGIC_BUTTON: 29,
  LEFT_SHOULDER: 30,
  RIGHT_SHOULDER: 31,
  LEFT_ARROW: 20,
  RIGHT_ARROW: 21,
  UP_ARROW: 22,
  DOWN_ARROW: 23,
  SNSR_SLEW: 41,
  LEFT_SHIFTER: 42,
  RIGHT_SHIFTER: 43,
  CUSTOM_1: 44,
  CUSTOM_2: 45,
  CUSTOM_3: 46,
  ACTION_WHEEL_1: 47,
  ACTION_WHEEL_2: 48,
  ACTION_WHEEL_3: 49
};

goog.object.extend(exports, proto.skills);
